import { SelectOption } from '@thought-river/ui-components';

export enum IssueSeverityLevel {
    SHOWSTOPPER = 'showstopper',
    HIGH = 'high',
    MEDIUM = 'medium',
    LOW = 'low',
    OK = 'ok',
    UNSCORED = 'unscored',
}

export const getIssueSeverityLevelLabel = (value: IssueSeverityLevel) => {
    switch (value) {
        case IssueSeverityLevel.SHOWSTOPPER:
            return 'Showstopper';
        case IssueSeverityLevel.HIGH:
            return 'High';
        case IssueSeverityLevel.MEDIUM:
            return 'Medium';
        case IssueSeverityLevel.LOW:
            return 'Low';
        case IssueSeverityLevel.OK:
            return 'Ok';
        case IssueSeverityLevel.UNSCORED:
            return 'None';
    }
};

export const getIssueSeverityLevelIconType = (value: IssueSeverityLevel) => {
    switch (value) {
        case IssueSeverityLevel.SHOWSTOPPER:
            return 'severity-showstopper';
        case IssueSeverityLevel.HIGH:
            return 'severity-high';
        case IssueSeverityLevel.MEDIUM:
            return 'severity-medium';
        case IssueSeverityLevel.LOW:
            return 'severity-low';
        case IssueSeverityLevel.OK:
            return 'severity-ok';
        case IssueSeverityLevel.UNSCORED:
            return 'severity-unscored';
    }
};

export const getIssueSeverityLevelBadgeType = (value: IssueSeverityLevel) => {
    switch (value) {
        case IssueSeverityLevel.SHOWSTOPPER:
            return 'severity-showstopper';
        case IssueSeverityLevel.HIGH:
            return 'severity-high';
        case IssueSeverityLevel.MEDIUM:
            return 'severity-medium';
        case IssueSeverityLevel.LOW:
            return 'severity-low';
        case IssueSeverityLevel.OK:
            return 'severity-ok';
        case IssueSeverityLevel.UNSCORED:
            return 'severity-unscored';
    }
};

export const issueSeveritySortOrder = {
    [IssueSeverityLevel.SHOWSTOPPER]: 1,
    [IssueSeverityLevel.HIGH]: 2,
    [IssueSeverityLevel.MEDIUM]: 3,
    [IssueSeverityLevel.LOW]: 4,
    [IssueSeverityLevel.OK]: 5,
    [IssueSeverityLevel.UNSCORED]: 6,
};

export const issueSeverityOptions: SelectOption[] = [
    {
        value: IssueSeverityLevel.SHOWSTOPPER,
        label: getIssueSeverityLevelLabel(IssueSeverityLevel.SHOWSTOPPER),
    },
    {
        value: IssueSeverityLevel.HIGH,
        label: getIssueSeverityLevelLabel(IssueSeverityLevel.HIGH),
    },
    {
        value: IssueSeverityLevel.MEDIUM,
        label: getIssueSeverityLevelLabel(IssueSeverityLevel.MEDIUM),
    },
    {
        value: IssueSeverityLevel.LOW,
        label: getIssueSeverityLevelLabel(IssueSeverityLevel.LOW),
    },
    {
        value: IssueSeverityLevel.OK,
        label: getIssueSeverityLevelLabel(IssueSeverityLevel.OK),
    },
    {
        value: IssueSeverityLevel.UNSCORED,
        label: getIssueSeverityLevelLabel(IssueSeverityLevel.UNSCORED),
    },
];
